<template>
    <default-layout>
        <div class="container-nzidoo">
            <page-title title="User Profile" />
            <SellerInformationComp :showReviews="true" />
        </div>
    </default-layout>
</template>

<script>
import SellerInformationComp from '@/components/user/SellerInformationComp.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import PageTitle from '@/components/templates/PageTitle.vue';

export default {
    data() {
        return {
        };
    },
    components: {
        SellerInformationComp,
        DefaultLayout,
        PageTitle,
    },
    async mounted() {
    },

    methods: {
 
    }
}
</script>